import { ApiResponseObject } from "../../types";
import { axios } from "../../utils/axios";
import {
  IFindCompanyByPibResponse,
  IGetUserCompaniesResponse,
  IGetUserRolesResponse,
  IResetPasswordPayload,
} from "./auth.types";

const loginSSO = () => {
  return axios.get("/LoginSSO");
};

const logoutSSO = () => {
  return axios.get("/LogoutSSO");
};

const loginSSOPro = () => {
  return axios.get("/LoginSSOPro");
};

const logoutSSOPro = () => {
  return axios.get("/LogoutSSOPro");
};

const getUserRoles = (): Promise<IGetUserRolesResponse> => {
  return axios.get("/getUserRoles");
};

const getUserCompanies = (): Promise<IGetUserCompaniesResponse> => {
  return axios.get("/svaDrustvaObveznika");
};

const activateDrustvo = (
  pib: string,
  tipId: number
): Promise<IFindCompanyByPibResponse> => {
  // if tp id dont call pib change
  return axios.get("/aktivacijaDrustva", {
    params: { identifikator: pib, tipId },
  });
};

const resetPassword = (
  payload: IResetPasswordPayload
): Promise<ApiResponseObject<boolean>> => {
  return axios.post("/resetujSifruKorisnika", payload);
};

const selectUserCompany = (
  drustvoId: number
): Promise<ApiResponseObject<{ drustvoId: number }>> => {
  return axios.get("/izabranoDrustvoObveznika", {
    params: { drustvoId },
  });
};

export const authRepo = {
  loginSSO,
  logoutSSO,
  loginSSOPro,
  logoutSSOPro,
  getUserRoles,
  resetPassword,
  activateDrustvo,
  getUserCompanies,
  selectUserCompany,
};
